import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import * as ReactRedux from 'react-redux';
import { toggleHelpSideBar } from 'VisualStatic/VisualStaticActions';
import withInit from 'WithInit';
import classnames from 'classnames';

export class HelpSideBarButton extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    window._track('Help | Helpful Sidebar', 'Visual-Static-Builder');
    e.stopPropagation();
    this.props.toggleHelpSideBar();
  }

  render() {
    const containerClass = classnames(
      'help-side-bar-btn-container',
      {
        hidden: this.props.isUserSessionsPanelOpen,
      },
    );

    return (
      <div className={containerClass}>
        <button
          className="help-side-bar-help-btn"
          onClick={this.onClick}
        >
          <img
            alt="Click to expand"
            src="images/builder-static/icon-question-mark-2x.png"
          />
          <span>Help</span>
        </button>
      </div>
    );
  }
}

const mapStateToProps = ({ SidebarSiteNavigationReducer }) => (
  {
    isUserSessionsPanelOpen: SidebarSiteNavigationReducer.isUserSessionsPanelOpen,
  }
);

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    toggleHelpSideBar,
  }, dispatch)
);

export const HelpSideBarButtonWithRedux = ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps,
)(HelpSideBarButton);

HelpSideBarButton.defaultProps = {
  isUserSessionsPanelOpen: false,
};

HelpSideBarButton.propTypes = {
  isUserSessionsPanelOpen: PropTypes.bool,
  toggleHelpSideBar: PropTypes.func.isRequired,
};

export default withInit(HelpSideBarButtonWithRedux, true);



// WEBPACK FOOTER //
// ./src-react/VisualStatic/HelpSideBarButton/index.jsx